/** 游戏埋点映射 */
export const gameEventMap = {
  ['Roullete']: {
    open: eventTracking.eventId.open_game_roullete,
    betting: eventTracking.eventId.betting_game_roullete
  },
  ['Teen Patti']: {
    open: eventTracking.eventId.open_game_teen_patti,
    betting: eventTracking.eventId.betting_game_teen_patti
  },
  ['Fruit Loops']: {
    open: eventTracking.eventId.open_game_fruit_loops,
    betting: eventTracking.eventId.betting_game_fruit_loops
  },
  ['Ferris Wheel']: {
    open: eventTracking.eventId.open_game_ferris_wheel,
    betting: eventTracking.eventId.betting_game_ferris_wheel
  },
  ['777']: {
    open: eventTracking.eventId.open_game_777,
    betting: eventTracking.eventId.betting_game_777
  },
  ['Greedy King']: {
    open: eventTracking.eventId.open_game_greedy_king,
    betting: eventTracking.eventId.betting_game_greedy_king
  }
} as const
